var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ant-register"},[_c('router-view',{staticClass:"content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }